import React from "react";
import PropertyRecordsImporterErrors from "./PropertyRecordsImporterErrors";
import ImportSelect from "./ImportSelect"
import ImportMultiSelect from "./ImportMultiSelect";

export default class AssignReservationDetails extends React.Component{
  constructor(props){
    super(props);
  };

  render() {
    return(
      this.renderReservationFields()
    );
  };

  renderReservationFields = () => {

    return (
      <div className="assign-details-wrapper">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-2">
            <label>Table Column</label>
          </div>
          <div className="col-md-3">
            <label>CSV Column</label>
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('booked_at')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('booked_at')}
            {this.renderFieldErrors('booked_at')}
          </div>
          <div className="col-md-3">
            {this.renderDateTimeFormats('booked_at')}
            {this.renderFieldErrors('booked_at_format')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('start_date')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('start_date')}
            {this.renderFieldErrors('start_date')}
          </div>
          <div className="col-md-3">
            {this.renderDateTimeFormats('start_date')}
            {this.renderFieldErrors('start_date_format')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('end_date')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('end_date')}
            {this.renderFieldErrors('end_date')}
          </div>
          <div className="col-md-3">
            {this.renderDateTimeFormats('end_date')}
            {this.renderFieldErrors('end_date_format')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('rate')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('rate')}
          </div>
          <div className="col-md-3">
            {this.renderDefaultSelect('rate')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('email')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('email')}
            {this.renderFieldErrors('email')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('customer_first_name')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('customer_first_name')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('customer_last_name')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('customer_last_name')}
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('room_type_name')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('room_type_name')}
            {this.renderFieldErrors('room_type_name')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('revenue_no_tax')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('revenue_no_tax')}
            {this.renderFieldErrors('revenue_no_tax')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('payment_amount')}*</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('payment_amount')}
            {this.renderFieldErrors('payment_amount')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('confirmation_number')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('confirmation_number')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{`${I18n.t('tax_name')} 1`}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('tax_name_1')}
            {this.renderFieldErrors('tax_name_1')}
          </div>
          <div className="col-md-3">
            {this.renderDefaultSelect('tax_name_1', 'tax_name_options')}
            {this.renderFieldErrors('tax_name_1')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{`${I18n.t('taxes_amount')} 1`}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('taxes_amount_1')}
            {this.renderFieldErrors('taxes_amount_1')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{`${I18n.t('tax_name')} 2`}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('tax_name_2')}
            {this.renderFieldErrors('tax_name_2')}
          </div>
          <div className="col-md-3">
            {this.renderDefaultSelect('tax_name_2', 'tax_name_options')}
            {this.renderFieldErrors('tax_name_2')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{`${I18n.t('taxes_amount')} 2`}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('taxes_amount_2')}
            {this.renderFieldErrors('taxes_amount_2')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{`${I18n.t('tax_name')} 3`}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('tax_name_3')}
            {this.renderFieldErrors('tax_name_3')}
          </div>
          <div className="col-md-3">
            {this.renderDefaultSelect('tax_name_3', 'tax_name_options')}
            {this.renderFieldErrors('tax_name_3')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{`${I18n.t('taxes_amount')} 3`}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('taxes_amount_3')}
            {this.renderFieldErrors('taxes_amount_3')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('fee_name')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('fee_name')}
            {this.renderFieldErrors('fee_name')}
          </div>
          <div className="col-md-3">
            {this.renderDefaultSelect('fee_name')}
            {this.renderFieldErrors('fee_name')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('fees_amount')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('fees_amount')}
            {this.renderFieldErrors('fees_amount')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('room_id')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('room_id')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('check_in_time')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('check_in_time')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('check_out_time')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('check_out_time')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('adults')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('adults')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('children')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('children')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('notes')}</label>
          </div>
          <div className="col-md-3">
            {this.renderMultiSelect('notes', true)}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('source_type')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('source_type')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('source')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('source')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('taxable')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('taxable')}
          </div>
        </div>
        <div className="row">
          <div className="col-md-2">
            <label>{I18n.t('generate_housekeeping')}</label>
          </div>
          <div className="col-md-3">
            {this.renderHeadersSelect('generate_housekeeping')}
          </div>
        </div>
      </div>
    );

  };

  renderHeadersSelect(selectName) {
    return (
      <ImportSelect name={selectName} options={this.props.fileHeaders} option={this.props.reservation[selectName]} onChange={this.props.onChange} error={this.renderFieldErrors(selectName)}/>
    );
  };

  renderMultiSelect(selectName) {
    return (
      <ImportMultiSelect name={selectName} options={this.props.fileHeaders} values={this.props.reservation[selectName]} onChange={this.props.onChangeNotes} error={this.renderFieldErrors(selectName)}/>
    );
  };

  renderDateTimeFormats(selectName) {
    var options = this.buildOptions()
    return (
      <div className="form-group data-type-input-wrapper">
        <ImportSelect name={selectName+"_format"} options={options} option={this.props.reservation[selectName+"_format"]} onChange={this.props.onChange} error={this.renderFieldErrors(selectName+"_format")}  placeholder={I18n.t("date_format")}/>
      </div>
    );
  };

  renderDefaultSelect(selectName, optionName = null) {
    return (
      <ImportSelect name={selectName+"_default"} options={this.props[optionName ? optionName : selectName+"_options"]} option={this.props.reservation[selectName+"_default"]} onChange={this.props.onChange} error={this.renderFieldErrors(selectName)} placeholder={I18n.t("default")}/>
    );
  };

  buildOptions() {
    return Object.keys(this.props.date_formats).map(format => {
      var obj = {
        id: format, 
        name: this.props.date_formats[format]
      }
      return obj
    });
  };

  renderErrors() {
    var errors = PropertyRecordsImporterErrors.reservations(this.props.errors);
    
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => { 
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b> {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field, noFormControl) {
    if (noFormControl === true) {
      var classname = "";
    } else {
      var classname = "form-control";
    }
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }
};